module.exports = __webpack_public_path__ + "static/img/banner_center.a46e260.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_center.png
// module id = WT2l
// module chunks = 12